import React from "react";
import "../css/Footer.css";
import {FOOTER_CONFIG} from "../constants/FooterConfig";
import LogoMedium from "../images/Logo_Medium.webp";
import {useNavigate} from "react-router-dom";

export const Footer = () => {
    const navigate = useNavigate();
    
    return (
        <div className="footers-module-container">
            <div className="footers-module-content">
                <img className={"footer-logo"} src={LogoMedium} alt={"Beyond Code Logo"}/>
                <div className={"contact-us-container"}>
                    {/*<div className={'footer-link'} onClick={() => navigate('/blog')}>Blog</div>*/}
                    <div className={'footer-link'} onClick={() => navigate('/educators')}>Beyond Code for Educators
                    </div>
                    <div className={'footer-link'} onClick={() => navigate('/blog-public')}>Blog
                    </div>
                    <div className={'footer-text'}>{FOOTER_CONFIG.contactUsContent}</div>
                    <p className={'footer-text'}>{FOOTER_CONFIG.allRights}</p>
                </div>
                <div className={"legal-text-container"}>
                    <a href={FOOTER_CONFIG.privacyUrl}>{FOOTER_CONFIG.privacyText}</a>
                    <a href={FOOTER_CONFIG.termsUrl}>{FOOTER_CONFIG.termsText}</a>
                </div>
            </div>
        </div>
    );
};